import { isType, Action } from "typescript-fsa";
import update from "immutability-helper";
import log from "loglevel";
import _ from "lodash";

import { apiRequest, isFailedResponseUnauthenticatedNotLogin } from "@api/actions";
import { logout } from "@auth/actions";
import * as actions from "../actions";
import { OldWataInternalState as State } from "../models";

const getInitialState = () => ({
    lastPath: null,
    lastUrl: null,
    lastLoaded: null,
    authenticated: false,
    authenticatedAt: null,
    loggedOutAt: null,
    iframeHeight: null,
} as State);

const reduce = (state: State = getInitialState(), action: Action<any>): State => {
    // State should never be null...
    if (state === null) {
        log.warn("oldwata state setting to null, resetting to initialState.");
        state = {} as State;
        state = update(state, { $set: getInitialState() });
    }

    if (isType(action, apiRequest)
        && action.payload != null
        && action.payload.has("options")
        && action.payload.options.endpoint != null
        && Array.isArray(action.payload.options.types)
        && action.payload.options.types.length > 0
        && action.payload.options.types[0] === actions.requestRoute
    ) {
        // Request
        const path = decodeURIComponent(action.payload.options.endpoint.replace("oldwata/route?path=", ""));
        return update(state, {
            lastPath: { $set: path },
        });
    }
    else if (isType(action, actions.routeSuccess)) {
        // Successful route
        return update(state, {
            lastUrl: { $set: action.payload },
            lastLoaded: { $set: new Date() },
        });
    }
    else if (isType(action, actions.login)) {
        // Set logged in, remove the session key from the URL
        return update(state, {
            authenticated: { $set: true },
            authenticatedAt: { $set: new Date() },
        });
    }
    else if (action.type === "oldwata-login-page") {
        // Expired token
        return update(state, {
            lastUrl: { $set: null },
            authenticated: { $set: false },
            loggedOutAt: { $set: new Date() },
        });
    }
    else if (action.type === "oldwata-height") {
        return update(state, {
            iframeHeight: { $set: action.payload },
        });
    }
    else if (isType(action, actions.routeFailure)) {
        // Failed route
        return update(state, { lastUrl: { $set: null }, lastLoaded: { $set: null } });
    }
    else if (isType(action, logout) || isFailedResponseUnauthenticatedNotLogin(action)) {
        // Clear the state on logout.
        return update(state, { $set: getInitialState() });
    }
    // Otherwise we do nothing
    return state;
};

export { reduce as oldwata, getInitialState };
